import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import ViolationFeesContent from './ApprehendingOfficersContent';
import useDebounce from '../../../../common/components/UseDebounce';
import CreateModal from '../modals/CreateModal';
import UpdateModal from '../modals/UpdateModal';

const form = {
  keyword: '',
};

function ApprehendingOfficersContainer({
  match,
  history,
  getApprehendingOfficers,
  apprehendingOfficerList,
  apprehendingOfficerListPager,
  isLoading,
  removeApprehendingOfficer,
  showApprehendingOfficer,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Apprehending Officers',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Apprehending Officers',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeApprehendingOfficer(data.id, () => {
          getApprehendingOfficers({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/ordinance-violation-receipts/settings/apprehending-officers/${id}`);
            showApprehendingOfficer(id);
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getApprehendingOfficers();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getApprehendingOfficers({ q: formData.keyword, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:apprehendingOfficerId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Apprehending Officers List"
            getData={getApprehendingOfficers}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:apprehendingOfficerId?`}
            listName="Apprehending Officers"
            label="Apprehending Officers List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <span style={{ color: '#2f89fc', fontWeight: 'bold' }}>
                  {_.get(item, 'attributes.name')}{' '}
                </span>{' '}
                <br />
              </div>
            )}
            isLoading={isLoading}
            selected={params.apprehendingOfficerId}
            data={apprehendingOfficerList}
            dataPager={apprehendingOfficerListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:apprehendingOfficerId?`}
                    render={() => (
                      <ViolationFeesContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:apprehendingOfficerId?`}
                  render={() =>
                    !params.apprehendingOfficerId && apprehendingOfficerList.length > 0 ? (
                      <Redirect to={`${match.url}/${_.get(apprehendingOfficerList, '0.id')}`} />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

ApprehendingOfficersContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getApprehendingOfficers: PropTypes.instanceOf(Function).isRequired,
  apprehendingOfficerList: PropTypes.instanceOf(Array).isRequired,
  apprehendingOfficerListPager: PropTypes.instanceOf(Object).isRequired,
  removeApprehendingOfficer: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showApprehendingOfficer: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  apprehendingOfficerList: _.get(api, `${c.GET_APPREHENDING_OFFICERS}.list`) || [],
  apprehendingOfficerListPager: _.get(api, `${c.GET_APPREHENDING_OFFICERS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_APPREHENDING_OFFICERS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ApprehendingOfficersContainer);
